import(/* webpackMode: "eager" */ "/vercel/path0/src/app/research/page.tsx");
